import InvestmentService from '../../services/InvestmentService';
import swal from 'sweetalert';
import toast from 'react-hot-toast';

// Action Types
export const INVESTMENT_LOADING = 'INVESTMENT_LOADING';
export const INVESTMENT_SUCCESS = 'INVESTMENT_SUCCESS';
export const INVESTMENT_FAIL = 'INVESTMENT_FAIL';
export const GET_INVESTMENTS = 'GET_INVESTMENTS';
export const GET_INVESTMENT_BY_ID = 'GET_INVESTMENT_BY_ID';
export const GET_INVESTMENT_STATISTICS = 'GET_INVESTMENT_STATISTICS';
export const GET_INVESTMENT_HISTORY = 'GET_INVESTMENT_HISTORY';
export const CLEAR_INVESTMENT_ERROR = 'CLEAR_INVESTMENT_ERROR';
export const SET_INVESTMENT_VALIDATION_ERRORS = 'SET_INVESTMENT_VALIDATION_ERRORS';

// Create Investment Action (now accepts an optional callback: (message, data, status))
export const createInvestmentAction = (investmentData, callback) => async (dispatch) => {
    dispatch({ type: INVESTMENT_LOADING });
    try {
        const result = await InvestmentService.createInvestment(investmentData);
        if (result.success) {
            dispatch({
                type: INVESTMENT_SUCCESS,
                payload: result.data
            });
            if (callback && typeof callback === 'function') {
                callback(result.message || 'Success', result.data, true);
            }
            return result;
        } 
        else {
            dispatch({
                type: INVESTMENT_FAIL,
                payload: result.message
            });
            if (result.errors && result.errors.length > 0) {
                dispatch({
                    type: SET_INVESTMENT_VALIDATION_ERRORS,
                    payload: result.errors
                });
            }
            if (callback && typeof callback === 'function') {
                callback(result.message || 'Failed', result, false);
            }
            return result;
        }
    } catch (error) {
        const errorMessage = error.message || 'An unexpected error occurred';
        dispatch({
            type: INVESTMENT_FAIL,
            payload: errorMessage
        });
        if (callback && typeof callback === 'function') {
            callback(errorMessage, null, false);
        }
        return { success: false, message: errorMessage };
    }
};

// Get All Investments Action
export const getInvestmentsAction = (params) => async (dispatch) => {
    dispatch({ type: INVESTMENT_LOADING });
    try {
        const result = await InvestmentService.getAllInvestments(params);
        if (result.success) {
            dispatch({
                type: GET_INVESTMENTS,
                payload: {
                    data: result.data,
                    pagination: result.pagination
                }
            });
        } 
        else {
            dispatch({
                type: INVESTMENT_FAIL,
                payload: result.message
            });
        }
        return result;
    } catch (error) {
        const errorMessage = error.message || 'Failed to fetch investments';
        dispatch({
            type: INVESTMENT_FAIL,
            payload: errorMessage
        });
        return { success: false, message: errorMessage };
    }
};

// Get Investment by ID Action
export const getInvestmentByIdAction = (id) => async (dispatch) => {
    dispatch({ type: INVESTMENT_LOADING });
    try {
        const result = await InvestmentService.getInvestmentById(id);
        if (result.success) {
            dispatch({
                type: GET_INVESTMENT_BY_ID,
                payload: result.data
            });
        } else {
            dispatch({
                type: INVESTMENT_FAIL,
                payload: result.message
            });
        }
        return result;
    } catch (error) {
        const errorMessage = error.message || 'Failed to fetch investment';
        dispatch({
            type: INVESTMENT_FAIL,
            payload: errorMessage
        });
        return { success: false, message: errorMessage };
    }
};

// Get Investment Statistics Action
export const getInvestmentStatisticsAction = (params) => async (dispatch) => {
    try {
        const result = await InvestmentService.getInvestmentStatistics(params);
        
        if (result.success) {
            dispatch({
                type: GET_INVESTMENT_STATISTICS,
                payload: result.data
            });
        }
        
        return result;
    } catch (error) {
        const errorMessage = error.message || 'Failed to fetch investment statistics';
        return { success: false, message: errorMessage };
    }
};

// Update Investment Action
export const updateInvestmentAction = (id, investmentData, navigate) => async (dispatch) => {
    dispatch({ type: INVESTMENT_LOADING });
    
    try {
        const result = await InvestmentService.updateInvestment(id, investmentData);
        
        if (result.success) {
            dispatch({
                type: INVESTMENT_SUCCESS,
                payload: result.data
            });
            
            swal({
                title: "Success!",
                text: result.message || "Investment updated successfully",
                icon: "success",
                button: "OK",
            }).then(() => {
                if (navigate) {
                    navigate('/investments');
                }
            });
            
            return result;
        } else {
            dispatch({
                type: INVESTMENT_FAIL,
                payload: result.message
            });
            
            if (result.errors && result.errors.length > 0) {
                dispatch({
                    type: SET_INVESTMENT_VALIDATION_ERRORS,
                    payload: result.errors
                });
            }
            
            swal({
                title: "Error!",
                text: result.message || "Failed to update investment",
                icon: "error",
                button: "OK",
            });
            
            return result;
        }
    } catch (error) {
        const errorMessage = error.message || 'An unexpected error occurred';
        dispatch({
            type: INVESTMENT_FAIL,
            payload: errorMessage
        });
        swal({
            title: "Error!",
            text: errorMessage,
            icon: "error",
            button: "OK",
        });
        return { success: false, message: errorMessage };
    }
};
export const addMoneyToInvestmentAction = (id, transactionData, callback) => async (dispatch) => {
    dispatch({ type: INVESTMENT_LOADING });
    
    try {
        const result = await InvestmentService.addMoneyToInvestment(id, transactionData);
        if (result.success) {
            dispatch({
                type: INVESTMENT_SUCCESS,
                payload: result.data
            });
            toast.success(result.message || "Amount added successfully");
            if (callback && typeof callback === 'function') {
                callback(true);
            }
            return result;
        } else {
            dispatch({
                type: INVESTMENT_FAIL,
                payload: result.message
            });
            toast.error(result.message || "Failed to add amount");
            if (callback && typeof callback === 'function') {
                callback(false);
            }
            return result;
        }
    } catch (error) {
        const errorMessage = error.message || 'An unexpected error occurred';
        dispatch({
            type: INVESTMENT_FAIL,
            payload: errorMessage
        });
        swal({
            title: "Error!",
            text: errorMessage,
            icon: "error",
            button: "OK",
        });
        
        return { success: false, message: errorMessage };
    }
};
export const withdrawMoneyFromInvestmentAction = (id, transactionData, callback) => async (dispatch) => {
    dispatch({ type: INVESTMENT_LOADING });
    
    try {
        const result = await InvestmentService.withdrawMoneyFromInvestment(id, transactionData);
        if (result.success) {
            dispatch({
                type: INVESTMENT_SUCCESS,
                payload: result.data
            });
            toast.success(result.message || "Amount withdrawn successfully");
            if (callback && typeof callback === 'function') {
                callback(true);
            }
            return result;
        } else {
            dispatch({
                type: INVESTMENT_FAIL,
                payload: result.message
            });
            
            toast.error(result.message || "Failed to withdraw amount");
            if (callback && typeof callback === 'function') {
                callback(false);
            }
            
            return result;
        }
    } catch (error) {
        const errorMessage = error.message || 'An unexpected error occurred';
        dispatch({
            type: INVESTMENT_FAIL,
            payload: errorMessage
        });
        
        swal({
            title: "Error!",
            text: errorMessage,
            icon: "error",
            button: "OK",
        });
        
        return { success: false, message: errorMessage };
    }
};

// Get Investment History Action
export const getInvestmentHistoryAction = (id, params) => async (dispatch) => {
    dispatch({ type: INVESTMENT_LOADING });
    
    try {
        const result = await InvestmentService.getInvestmentHistory(id, params);
        
        if (result.success) {
            dispatch({
                type: GET_INVESTMENT_HISTORY,
                payload: {
                    data: result.data,
                    pagination: result.pagination
                }
            });
        } else {
            dispatch({
                type: INVESTMENT_FAIL,
                payload: result.message
            });
        }
        
        return result;
    } catch (error) {
        const errorMessage = error.message || 'Failed to fetch investment history';
        dispatch({
            type: INVESTMENT_FAIL,
            payload: errorMessage
        });
        
        return { success: false, message: errorMessage };
    }
};

// Record Investment Return Action
export const recordInvestmentReturnAction = (id, returnData) => async (dispatch) => {
    dispatch({ type: INVESTMENT_LOADING });
    
    try {
        const result = await InvestmentService.recordInvestmentReturn(id, returnData);
        
        if (result.success) {
            dispatch({
                type: INVESTMENT_SUCCESS,
                payload: result.data
            });
            
            swal({
                title: "Success!",
                text: result.message || "Investment return recorded successfully",
                icon: "success",
                button: "OK",
            });
            
            return result;
        } else {
            dispatch({
                type: INVESTMENT_FAIL,
                payload: result.message
            });
            
            swal({
                title: "Error!",
                text: result.message || "Failed to record investment return",
                icon: "error",
                button: "OK",
            });
            
            return result;
        }
    } catch (error) {
        const errorMessage = error.message || 'An unexpected error occurred';
        dispatch({
            type: INVESTMENT_FAIL,
            payload: errorMessage
        });
        
        swal({
            title: "Error!",
            text: errorMessage,
            icon: "error",
            button: "OK",
        });
        
        return { success: false, message: errorMessage };
    }
};

// Close Investment Action
export const closeInvestmentAction = (id) => async (dispatch) => {
    dispatch({ type: INVESTMENT_LOADING });
    
    try {
        const result = await InvestmentService.closeInvestment(id);
        
        if (result.success) {
            dispatch({
                type: INVESTMENT_SUCCESS,
                payload: null
            });
            
            swal({
                title: "Success!",
                text: result.message || "Investment closed successfully",
                icon: "success",
                button: "OK",
            });
            
            return result;
        } else {
            dispatch({
                type: INVESTMENT_FAIL,
                payload: result.message
            });
            
            swal({
                title: "Error!",
                text: result.message || "Failed to close investment",
                icon: "error",
                button: "OK",
            });
            
            return result;
        }
    } catch (error) {
        const errorMessage = error.message || 'An unexpected error occurred';
        dispatch({
            type: INVESTMENT_FAIL,
            payload: errorMessage
        });
        
        swal({
            title: "Error!",
            text: errorMessage,
            icon: "error",
            button: "OK",
        });
        
        return { success: false, message: errorMessage };
    }
};

// Clear Error Action
export const clearInvestmentError = () => ({
    type: CLEAR_INVESTMENT_ERROR
});
